import React, { useCallback } from 'react';
import { faBolt, faBoltSlash, faEllipsisV, faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ePermissions } from '../../../../types/administration/userAdministration/ePermissions';
import { ButtonDropdown } from 'ui-toolkit';
import { IFeatureIdentityData } from '../../../../types/administration/features/IFeature';
import { RedGreenOptions } from '../../subComponents/RedGreenOptions';
import { PermissionWrapper } from '../../../accessControl/PermissionWrapper';
import {
  useDeleteFeatureIdentityMutation,
  useUpdateFeatureIdentityMutation,
} from '../../../../API/administration/FeaturesAPI';
import { checkForMutationSuccess } from '../../../../API/checkForMutationSuccess';
import { isResponseOnOrOff } from './FeatureRoleMenuDropdown';

interface IFeatureMenuDropdownProps {
  feature: IFeatureIdentityData;
}

export const FeatureIdentitiesMenuDropdown: React.FC<IFeatureMenuDropdownProps> = ({ feature }) => {
  const [updateFeatureIdentity] = useUpdateFeatureIdentityMutation();
  const [deleteFeatureIdentity] = useDeleteFeatureIdentityMutation();

  const onUpdateFeatureIdentity = useCallback(async () => {
    const response = await updateFeatureIdentity({
      name: feature.name,
      isOn: !feature.isOn,
      identityId: feature.identityId,
    });
    checkForMutationSuccess(response, `Feature Identity is now ${isResponseOnOrOff(response)}`);
  }, [feature, updateFeatureIdentity]);

  const onDeleteFeatureIdentity = useCallback(async () => {
    const response = await deleteFeatureIdentity({ name: feature.name, identityId: feature.identityId });
    checkForMutationSuccess(response, 'Feature Identity Deletion');
  }, [feature, deleteFeatureIdentity]);

  return (
    <PermissionWrapper allowedPermissions={[ePermissions.FeatureEdit]}>
      <ButtonDropdown
        intent={'ghost'}
        children={<FontAwesomeIcon icon={faEllipsisV} />}
        items={[
          {
            children: <RedGreenOptions isEnabled={feature.isOn} activeIcon={faBolt} inactiveIcon={faBoltSlash} />,
            onClick: onUpdateFeatureIdentity,
          },
          {
            children: (
              <>
                <FontAwesomeIcon icon={faTrash} />
                Delete
              </>
            ),
            onClick: onDeleteFeatureIdentity,
          },
        ]}
      />
    </PermissionWrapper>
  );
};
